module.exports = __webpack_public_path__ + "static/img/AboutImgTwo.ea716de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/AboutImgTwo.png
// module id = v9IE
// module chunks = 1